import AsyncLoader from 'commons/components/AsyncLoader';

export { SEGMENTS_PATH } from './constants';

export default AsyncLoader(() => import('./Segments'));
